import { ThunkType } from "../../../../../core/store/reducers";
import { getQuarterlySecurityExcel } from "../api/getQuarterlySecurityExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../quarterlySecurityDataSlice";

export const downloadQuarterlySecurityExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.securityCommission.quarterlylSecurity;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getQuarterlySecurityExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "QuarterlySecurityTrading.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));

};
